/**
 * Espejo de Backend-IOT-Web/app/services/alert_count_service.py.
 *
 * El backend ya decide el estado de cada variable y lo envía como `alert_state`
 * en cada VariableData, tanto por HTTP como por MQTT (el topic
 * myindustrialdata/{device_id} se publica con el mismo serializer). La rama
 * local de abajo es sólo un respaldo para payloads generados antes de que ese
 * campo existiera, o para pestañas abiertas durante el despliegue.
 *
 * Invariante que garantiza: high_count + medium_count + low_count === total_count,
 * y total_count es el número de variables para las que la UI dibuja semáforo.
 */

const STRING_VARIABLE_TYPE = 3;

/**
 * @returns {'high'|'medium'|'low'|null} null = no dibuja semáforo, no se cuenta.
 */
export function variableAlertState(variable) {
    if (!variable) return null;

    // El backend ya resolvió la regla: se respeta tal cual (incluido null).
    if (variable.alert_state !== undefined) return variable.alert_state;

    if (variable.disable_alerts) return null;

    const type = variable.variable?.type;
    const hasBoolLimit = variable.bool_alert_value !== null
        && variable.bool_alert_value !== undefined;
    if (type === STRING_VARIABLE_TYPE && !hasBoolLimit) return null;

    if (variable.high_active) return 'high';
    if (variable.medium_active) return 'medium';
    return 'low'; // incluye "todavía sin estado" -> OK
}

/**
 * Cuenta los estados de una lista de variables.
 * @returns {{high_count:number, medium_count:number, low_count:number, total_count:number}}
 */
export function countAlertStates(variables) {
    const counts = {high_count: 0, medium_count: 0, low_count: 0, total_count: 0};
    (variables || []).forEach((variable) => {
        const state = variableAlertState(variable);
        if (!state) return;
        counts[`${state}_count`] += 1;
        counts.total_count += 1;
    });
    return counts;
}
